import * as stylex from "@stylexjs/stylex";
import React, { useContext, useState } from "react";
import { defineMessage, useIntl } from "react-intl";
import { ExplorerContext } from "../../domain";
import { Grid } from "../../materials";
import { colors, layoutAreas } from "../../materials/consts.stylex";
import { typography } from "../../materials/typography.stylex";
import { ExplorerProvider } from "./explorer-provider";
import { Figure } from "./figure";
const stylexStyles = {
    root: {
        kLKAdn: "x6gltce",
        kGO01o: "x163t5y5",
        kEafiO: "x178xt8z",
        kPef9Z: "x13fuv20",
        kLZC3w: "xw192ze",
        kWkggS: "x2pqsqo",
        $$css: true
    },
    tab: {
        kMzoRj: "xmkeg23",
        ksu8eU: "x1y0btm7",
        kVAM5u: "x5snjlz",
        kIxVMA: "x2b5lcy",
        ksF3WI: "x1lzl9kk",
        kWkggS: "x12peec7",
        kt9PQ7: "x1qhh985",
        kMwMTN: "xjvpvmj",
        kmVPX3: "xdqdrvq",
        km5ZXQ: "x1db2dqx",
        kkrTdU: "x1ypdohk",
        $$css: true
    },
    tabActive: {
        kt9PQ7: "x2x41l1",
        kfdmCh: "x1q0q8m5",
        kL6WhQ: "x1ddlw9d",
        kWkggS: "x2pqsqo",
        kMwMTN: "x12klvby",
        $$css: true
    }
};
const TABS = [
    "trajectories",
    "simulations"
];
const tabNameLookup = {
    trajectories: defineMessage({
        id: "fig.learning.trajectories.explorer.tab.trajectories.name",
        defaultMessage: "Trajectories"
    }),
    simulations: defineMessage({
        id: "fig.learning.simulations.explorer.tab.simulations.name",
        defaultMessage: "Simulations"
    })
};
const tabTitleLookup = {
    trajectories: defineMessage({
        id: "fig.learning.trajectories.explorer.tab.trajectories.title",
        defaultMessage: "Learning trajectories builder"
    }),
    simulations: defineMessage({
        id: "fig.learning.simulations.explorer.tab.simulations.title",
        defaultMessage: "Policy simulator"
    })
};
const ErrorMessage = ()=>{
    const { immer: [state] } = useContext(ExplorerContext);
    return state.status === "error" && state.errorMessage ? <div className="x1e2nbdu">{state.errorMessage}</div> : null;
};
export const Explorer = ({ children })=>{
    const [activeTab, setActiveTab] = useState("trajectories");
    const intl = useIntl();
    const handleClick = (tabId)=>{
        setActiveTab(tabId);
    };
    /*
  FIXME: Share url for figures depends on div ids to link to the correct page section. Since the figure
  TRAJECTORIES_EXPLORER_SIMULATION is only present when the user clicks on the Simulation tab, it
  doesn't exist on page load. In order for the user to still be taken to the Data Explorer, we
  specify its id here.
  */ return <ExplorerProvider>
      <div className="x1rg5ohu x1n2onr6 x1t1qrwb xou54vl x4i7bpe" id="TRAJECTORIES_EXPLORER_SIMULATION">
        {TABS.map((tab, index)=><button key={index} {...stylex.props(typography.body2Hero, stylexStyles.tab, tab === activeTab && stylexStyles.tabActive)} onClick={()=>handleClick(tab)}>
            {intl.formatMessage(tabNameLookup[tab])}
          </button>)}
      </div>
      <Grid layout="explorer" sx={[
        stylexStyles.root
    ]}>
        <ErrorMessage/>
        {React.Children.map(children, (child)=>{
        if (React.isValidElement(child) && child.props) {
            if (activeTab === "trajectories" && child.type === TrajectoriesTab) return child;
            if (activeTab === "simulations" && child.type === SimulationsTab) return child;
        }
        return null;
    })}
      </Grid>
    </ExplorerProvider>;
};
export const TrajectoriesTab = ({ children })=>{
    const intl = useIntl();
    return <>
      <h3 {...stylex.props(typography.heading4)}>{intl.formatMessage(tabTitleLookup.trajectories)}</h3>
      <p className="xj1urod">{children}</p>

      <Figure id="TRAJECTORIES_EXPLORER_CURRENT"/>
    </>;
};
export const SimulationsTab = ({ children })=>{
    const intl = useIntl();
    return <>
      <h3 {...stylex.props(typography.heading4)}>{intl.formatMessage(tabTitleLookup.simulations)}</h3>
      <p className="xj1urod">{children}</p>

      <Figure id="TRAJECTORIES_EXPLORER_SIMULATION"/>
    </>;
};
